import { render, staticRenderFns } from "./HomeList.vue?vue&type=template&id=5fc8a473&"
import script from "./HomeList.vue?vue&type=script&lang=js&"
export * from "./HomeList.vue?vue&type=script&lang=js&"
import style0 from "./HomeList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports